import axios from "axios";
import { baseUrlPostGres } from "../constant";
import HandleError from "../HandleError";
import { apiHeader } from "./ApiHeader";
import { IS_LOADING, DASHBOARD_SUCCESS, DASHBOARD_ERROR } from "./Type";
import { apiVersion } from "src/utils/apiVersion";


export const GetDashboardAction = () => async (dispatch) => {
  dispatch({ type: IS_LOADING });

    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/dashboard/list`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: DASHBOARD_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: DASHBOARD_ERROR,
                payload: errors
            })
        })
}

export const GetDashboardVendorDetails = (vendorId) => async (dispatch) => {
  console.log("vendorId--->>",vendorId);
  dispatch({ type: IS_LOADING });
  await axios.post(
    `${baseUrlPostGres()}/admin/${apiVersion.v1}/dashboard/dashboard_vender_details`,
    { id: vendorId },
    { headers: apiHeader() }
  )
  .then((response) => {
    console.log("New Dashboard API response:", response.data);
    dispatch({
      type: DASHBOARD_SUCCESS,
      payload: response.data,
    });
  })
  .catch((error) => {
    console.error("New Dashboard API error:", error);
    HandleError(error.response?.data);
    dispatch({
      type: DASHBOARD_ERROR,
      payload: error,
    });
  });
};

export const ResetDashboardAction = () => async (dispatch) => {
  dispatch({
    type: DASHBOARD_SUCCESS,
    payload: {},
  });
};
